import React from 'react'

export default function MandoxExchange() {
  return (
    <div className="min-h-screen px-4 py-12 sm:py-16">
      <div className="max-w-4xl mx-auto flex items-center justify-center">
        <img
          src="https://static.lumi.new/5f/5f5ca623a5fb21183ad53d14714ee113.webp"
          alt="Mandox Exchange - Coming Soon"
          className="w-full h-auto rounded-2xl shadow-[0_0_40px_rgba(255,255,255,0.15)]"
        />
      </div>
    </div>
  )
}
